// pb-gift-campaigns.js — Gratis cadeau per campagne
//
// Flow: ?gift=<key> → cookie (30d) → auto-add zodra cart ≥ drempel → popup
// De 100% korting komt van de Shopify Discount Function (op variant-ID).
//
// Config staat in snippets/pb-gift-campaigns.liquid (window.PB_GIFTS).
//
// Er is altijd maximaal ÉÉN campagne actief: de laatst geopende link wint.
// Een cadeau van een eerdere campagne wordt uit de cart gehaald. Dat voorkomt
// dat iemand alle campagnelinks langsgaat en meerdere gratis producten sprokkelt.

(function () {
  var GIFTS = window.PB_GIFTS || {};

  var PARAM_KEY       = 'gift';
  var COOKIE_KEY      = 'pb_gift_campaign';
  var ATTR_KEY        = '_pb_gift';
  var SUPPRESS_PREFIX = 'pb_gift_suppressed:';
  var WELCOME_PREFIX  = 'pb_gift_welcome_shown:';

  // Legacy (eerste versie deed alleen de beauty bag) — blijft ondersteund zodat
  // bezoekers met een lopende sessie hun cadeau niet verliezen.
  var LEGACY_KEY      = 'beauty-bag';
  var LEGACY_COOKIE   = 'pb_beauty_bag_campaign';
  var LEGACY_ATTR     = '_beauty_bag';
  var LEGACY_SUPPRESS = 'pb_beauty_bag_suppressed';

  // --- Cookies ---

  function readCookie(name) {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(name + '=') === 0) {
        return decodeURIComponent(parts[i].slice(name.length + 1));
      }
    }
    return null;
  }

  function writeCookie(name, value) {
    var parts = [
      name + '=' + encodeURIComponent(value),
      'path=/',
      'max-age=' + (60 * 60 * 24 * 30),
      'SameSite=Lax'
    ];
    // Alleen het brede .planetb.care domein zetten als we daadwerkelijk op een
    // planetb.care host zitten — anders (preview/myshopify) faalt de cookie stil.
    if (/(^|\.)planetb\.care$/i.test(window.location.hostname)) {
      parts.splice(2, 0, 'domain=.planetb.care');
    }
    document.cookie = parts.join('; ');
  }

  // --- Actieve campagne ---

  function activeKey() {
    var key = readCookie(COOKIE_KEY);
    if (key && GIFTS[key]) return key;
    if (readCookie(LEGACY_COOKIE) && GIFTS[LEGACY_KEY]) return LEGACY_KEY;
    return null;
  }

  function isSuppressed(key) {
    try {
      if (sessionStorage.getItem(SUPPRESS_PREFIX + key) === '1') return true;
      if (key === LEGACY_KEY && sessionStorage.getItem(LEGACY_SUPPRESS) === '1') return true;
    } catch (_) {}
    return false;
  }

  function clearSuppression(key) {
    try {
      sessionStorage.removeItem(SUPPRESS_PREFIX + key);
      if (key === LEGACY_KEY) sessionStorage.removeItem(LEGACY_SUPPRESS);
    } catch (_) {}
  }

  // Aangeroepen door cart-lines.js wanneer de bezoeker het cadeau zelf weghaalt.
  window.pbGiftSuppress = function (key) {
    var target = key || activeKey();
    if (!target) return;
    try { sessionStorage.setItem(SUPPRESS_PREFIX + target, '1'); } catch (_) {}
  };

  // Backwards compat — oude naam bleef mogelijk ergens in gebruik.
  window.pbBeautyBagSuppress = function () { window.pbGiftSuppress(); };

  // --- Cadeau-regels herkennen ---

  function lineGiftKey(node) {
    var attrs = (node && node.attributes) || [];
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].key === ATTR_KEY && attrs[i].value) return attrs[i].value;
      if (attrs[i].key === LEGACY_ATTR && attrs[i].value === 'true') return LEGACY_KEY;
    }
    return null;
  }

  // Vergelijkt de variant van een cadeau-regel met wat er nu geconfigureerd staat.
  // Wisselt een campagne van variant (bv. andere kleur), dan is de oude regel niet
  // meer de juiste en wordt hij vervangen. Kunnen we de variant niet lezen, dan
  // laten we de regel met rust — anders krijg je een verwijder/toevoeg-lus.
  function isSameVariant(node, gift) {
    var id = node && node.merchandise && node.merchandise.id;
    if (!id || !gift || !gift.variantId) return true;
    return String(id).split('/').pop() === String(gift.variantId);
  }

  function isAutoGift(node) {
    var attrs = (node && node.attributes) || [];
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].key === '_auto_gift' && attrs[i].value === 'true') return true;
    }
    return false;
  }

  // --- Subtotaal (excl. gift cards, memberships, auto-gifts en cadeaus zelf) ---

  var EXCLUDED_PRODUCT_IDS = new Set([
    'gid://shopify/Product/4849416896586',   // Gift card
    'gid://shopify/Product/15652866294134',  // Membership
    'gid://shopify/Product/15630492238198',  // Membership
  ]);

  function qualifyingSubtotal(gqlCart) {
    var edges = (gqlCart && gqlCart.lines && gqlCart.lines.edges) || [];
    if (!edges.length) {
      return Math.round(parseFloat(
        (gqlCart && gqlCart.cost && gqlCart.cost.subtotalAmount && gqlCart.cost.subtotalAmount.amount) || 0
      ) * 100);
    }
    return Math.round(
      edges.reduce(function (sum, edge) {
        var node = edge.node;
        var pid = (node.merchandise && node.merchandise.product && node.merchandise.product.id) || '';
        if (EXCLUDED_PRODUCT_IDS.has(pid)) return sum;
        if (isAutoGift(node)) return sum;
        if (lineGiftKey(node)) return sum;
        return sum + parseFloat((node.cost && node.cost.totalAmount && node.cost.totalAmount.amount) || 0);
      }, 0) * 100
    );
  }

  function findGiftLines(gqlCart) {
    var edges = (gqlCart && gqlCart.lines && gqlCart.lines.edges) || [];
    var out = [];
    for (var i = 0; i < edges.length; i++) {
      var key = lineGiftKey(edges[i].node);
      if (key) out.push({ key: key, node: edges[i].node });
    }
    return out;
  }

  // --- Popups ---

  function euro(cents) {
    var n = (cents || 0) / 100;
    return '€' + (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ','));
  }

  function fill(popup, selector, text) {
    var el = popup.querySelector(selector);
    if (el) el.textContent = text;
  }

  function openPopup(popup) {
    popup.removeAttribute('hidden');
    popup.classList.add('pbg-popup--visible');
    window.PBOverlayStack?.push(popup);
  }

  var addedPopupShown = false;

  function showAddedPopup(gift) {
    if (addedPopupShown) return;
    var popup = document.getElementById('PBGiftAddedPopup');
    if (!popup) return;

    var label = gift.label || 'cadeau';
    fill(popup, '[data-pb-gift-title]', gift.addedTitle || ('Je gratis ' + label + ' is toegevoegd!'));
    fill(popup, '[data-pb-gift-body]',
      'Je ontvangt een gratis ' + label + ' bij een bestelling van minimaal ' +
      euro(gift.threshold) + '. Zolang de voorraad strekt.');

    openPopup(popup);
    addedPopupShown = true;
  }

  function showWelcomePopup(key) {
    var gift = GIFTS[key];
    var popup = document.getElementById('PBGiftWelcomePopup');
    if (!gift || !popup) return;

    try {
      if (sessionStorage.getItem(WELCOME_PREFIX + key) === '1') return;
      sessionStorage.setItem(WELCOME_PREFIX + key, '1');
    } catch (_) {}

    var label = gift.label || 'cadeau';
    var titleEl = popup.querySelector('[data-pb-gift-title]');
    if (titleEl) titleEl.textContent = gift.title || ('Gratis ' + label);

    var eyebrow = popup.querySelector('[data-pb-gift-eyebrow]');
    if (eyebrow) {
      var eyebrowText = gift.eyebrow || gift.lead || '';
      if (eyebrowText) {
        eyebrow.textContent = eyebrowText;
        eyebrow.removeAttribute('hidden');
      } else {
        eyebrow.textContent = '';
        eyebrow.setAttribute('hidden', '');
      }
    }

    fill(popup, '[data-pb-gift-body]',
      gift.body ||
      ('Shop voor minimaal ' + euro(gift.threshold) + ' en je gratis ' + label +
      ' wordt automatisch aan je winkelmandje toegevoegd. Zolang de voorraad strekt.'));
    fill(popup, '[data-pb-gift-body-mobile]',
      gift.bodyMobile || gift.body ||
      ('Shop voor minimaal ' + euro(gift.threshold) + ' en je gratis ' + label +
      ' wordt automatisch aan je winkelmandje toegevoegd. Zolang de voorraad strekt.'));

    fill(popup, '[data-pb-gift-eligibility]', gift.eligibility || 'GELDIG OP AL ONZE MERKEN');
    fill(popup, '[data-pb-gift-footnote]', gift.footnote || 'Zolang de voorraad strekt.');

    var cta = popup.querySelector('[data-ag-cta]');
    if (cta && gift.cta) cta.textContent = gift.cta;

    // Korte vertraging zodat de pagina eerst rendert
    setTimeout(function () { openPopup(popup); }, 600);
  }

  // --- Kern sync-logica ---

  var syncing = false;
  var timer;

  function notify() {
    document.dispatchEvent(new CustomEvent('pb:cart:updated', {
      detail: { source: 'pb_gift' }
    }));
  }

  // Gebruik de cart uit het event indien aanwezig; val alleen op een eigen
  // refresh terug wanneer er geen cart meegegeven is. Dit voorkomt dubbele,
  // gelijktijdige refreshes (die PBCart een CONFLICT geven en een nieuwe lege
  // cart laten aanmaken).
  // De gift-handler geeft in zijn 'gifts'-event een cart mee van vóór zijn
  // mutatie (stale) — die negeren we en doen we een verse refresh.
  function resolveCart(eventCart, src) {
    if (eventCart && eventCart.lines && src !== 'gifts') return Promise.resolve(eventCart);
    return window.PBCart.refresh();
  }

  function sync(eventCart, src) {
    var key = activeKey();
    if (!key) return;
    if (isSuppressed(key)) return;

    var gift = GIFTS[key];
    if (!gift || !gift.variantId) return;

    if (syncing) return;
    syncing = true;

    resolveCart(eventCart, src)
      .then(function (cart) {
        var subtotal  = qualifyingSubtotal(cart);
        var eligible  = subtotal >= (gift.threshold || 0);
        var giftLines = findGiftLines(cart);

        var mine  = null;
        var stale = [];
        for (var i = 0; i < giftLines.length; i++) {
          if (giftLines[i].key === key && isSameVariant(giftLines[i].node, gift)) {
            mine = giftLines[i].node;
          } else {
            stale.push(giftLines[i].node);
          }
        }

        // Eén mutatie per doorloop: de resulterende cart-update triggert de
        // volgende sync. Zo muteren we nooit gelijktijdig op dezelfde cart.
        if (stale.length) {
          return window.PBCart.removeLine(stale[0].id).then(notify);
        }

        if (eligible && !mine) {
          return window.PBCart.addLine(gift.variantId, 1, [
            { key: ATTR_KEY, value: key }
          ]).then(function () {
            showAddedPopup(gift);
            notify();
          });
        }

        if (!eligible && mine) {
          return window.PBCart.removeLine(mine.id).then(notify);
        }
      })
      .catch(function (err) {
        console.warn('[PBGift] sync error', err);
      })
      .finally(function () {
        syncing = false;
      });
  }

  // 260ms > de 180ms van cart-gift-handler, zodat die zijn mutatie eerst afrondt.
  function schedule(eventCart, src) {
    clearTimeout(timer);
    timer = setTimeout(function () { sync(eventCart, src); }, 260);
  }

  // --- Initialisatie ---

  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  // 1. Detecteer URL param → zet cookie en toon welkomst-popup
  (function detectParam() {
    var key;
    try {
      key = new URLSearchParams(window.location.search).get(PARAM_KEY);
    } catch (_) {
      return;
    }
    if (!key || !GIFTS[key]) return;

    writeCookie(COOKIE_KEY, key);
    // Nieuwe campagne-intentie: een eerdere weigering vervalt
    clearSuppression(key);
    whenReady(function () { showWelcomePopup(key); });
  })();

  // 2. Sync bij laden (eigen refresh nodig — nog geen event-cart)
  whenReady(function () { schedule(); });

  // 3. Sync na elke cart-update; negeer onze eigen mutaties
  document.addEventListener('pb:cart:updated', function (e) {
    var src = (e.detail && e.detail.source) || '';
    if (src === 'pb_gift' || src === 'beauty_bag') return;
    schedule(e.detail && e.detail.cart, src);
  });
})();
